import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { UtmPreservationService } from '../services/utm-preservation.service';
import { ChannelConfigService } from '../services/channel-config.service';

/**
 * Blocks /indique-pme when user is in UTM context.
 * /indica is allowed with UTM (channel indication flow).
 */
@Injectable({
  providedIn: 'root',
})
export class IndicationUtmBlockGuard implements CanActivate {
  private platformId = inject(PLATFORM_ID);
  private router = inject(Router);
  private utmPreservationService = inject(UtmPreservationService);
  private channelConfigService = inject(ChannelConfigService);


  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    if (this.channelConfigService.showIndiqueMenu) {
      return true;
    }

    if (route.routeConfig?.path === 'indica') {
      return true;
    }

    const inUtmUrl = this.hasAnyUtmInCurrentUrl();
    const inUtmSession = this.utmPreservationService.isUtmEnabled();

    if (inUtmUrl || inUtmSession) {
      return this.router.parseUrl('/');
    }

    return true;
  }

  private hasAnyUtmInCurrentUrl(): boolean {
    try {
      const params = new URLSearchParams(window.location.search);
      return Array.from(params.keys()).some(k => k.toLowerCase().startsWith('utm_'));
    } catch {
      return false;
    }
  }
}


